<template>
	<div id="appbox">
		<div class="top">
			<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 32px;left: 40px;width: 225px;height: 80px;object-fit: contain;" @click="gohome">
			<div class="nav" style="font-size: 24px;font-family: 'Courier New', Courier, monospace;text-shadow: 2px 2px 4px rgba(46,41,41,.6);">
				<div class="nav_box" @click="gohome" >首页</div>
				<div class="nav_box" style="color: #000;text-shadow: none;" >基地信息</div>
				<div class="nav_box" @click="goCourse(item.id)" :style="{ color: tags_type==11 ? '#FE7C2B' : '' }" v-for="(item,index) in colCate" v-bind:key="index" >{{ item.title }}</div>
				
				
			</div>
		<!-- <div class="search">
			<el-input v-model="keyword" placeholder="请输入产品名称" ></el-input>
			<el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
		</div> -->
		</div>
			
		<div  class="campbox" style="margin-top: 40px;">
			
			<div class="homecamp_item" :data-id="item.id" v-for="(item, key) in camplist" :key="key" @click="detail(item.id)" >
				<div class="column2_img" style="height: 180px;position: relative;" :data-id="item.id" >
					<img :src="item.cover" :data-id="item.id" alt="" srcset="" >
					<div   class="camp_box">
						<div v-for="(tags,tag_index) in item.tags" class="camp_tag"  :style="{ backgroundColor: tags.background, color: tags.color  }">	
						{{ tags.title }}
					</div>
					</div>
				</div>
				
				<div class="hcamp_title" :data-id="item.id">
					<div class="item_title"
						style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;"
						:data-id="item.id">
						{{ item.title }}
					</div>
					<div class="homecamp_msg"
						style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;"
						:data-id="item.id">
						{{ item.province }} -{{ item.city }}-{{ item.area }}
					</div>
					<div class="homecamp_msg"
						style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;"
						:data-id="item.id"  v-if="item.address">
						{{ '详细地址:' + item.address }}
					</div>
				</div>
			</div>
			<div class="pages_total">
					<el-pagination
					  background
					  :page-size="12"
					  
					  :hide-on-single-page="true"
					  @current-change="pagechange"
					  layout="total, prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
		</div>
		<!-- footer -->
		

	</div>
</template>

<script>
import { getsupplierlst,getsupplier,getNewslist, getCategory, getCamplist, getPc, getMapcamp, getRegion, getPlate, getCamplisttest, getbottomnav, getcamptags ,getcolCate} from '@/request/api'

export default {
	name: "Camplist",
	// components: {
	//   navTab
	// },
	data() {
		return {
			bottomnav: [],
			top_search_url: '/Camplist',
			
			
			stitle: '',
			options: [{
				value: '/Camplist',
				label: '营地搜索'
			},],
			platelist: [],
			activeIndex2: '/Camplist',
		
			camptypes: [
				{ text: '全部', value: 0 },
				{ text: '基地', value: 2 },
				{ text: '营地', value: 1 },
			],
			camptype: "",
			camplist: [],
			quicklist: [],
			maplist: [],
			aclist: [],
			newsiconon: '',
			category_id: '',
			total: 0,
			page_index: 1,
			uuid: '',
			newsdata: {},
			pcsetdata: {},
			openmap: {},
			show: false,
			showinfowindow: false,
			regionlist: [],
			vanregionlist: [],
			camptags: [],
			vancamptags: [],
			tags_type: 0,
			region_type: '',
			modules: '',
			colCate:[],
			camp_value:"",
			// 产品名称筛选
			keyword:''
			
		}
	},
	beforeCreate() {
		// const loading = this.$loading({
		// 	lock: true,
		// 	text: '页面载入……',
		// 	// spinner: 'el-icon-loading',
		// 	background: '#ffffff'
		// });
	},
	created() {
		// this.getpcset()
		if(this.$route.query.tags_id){
			this.tags_type=this.$route.query.tags_id
		}
		
	},
	mounted() {
		// const { stitle, region_type } = this.$route.query;
		// this.stitle = stitle || ''
		// this.region_type = region_type || ''
		// window.addEventListener('resize', this.handleResize, true)
		// var token = localStorage.getItem('token') || ''
		// this.token = token
		// this.getPlate()
		// this.getbottomnav()
		// // const { id } = this.$route.query;
		// // this.uuid = id
		this.getlist()
		// this.getMapcamp()
		// this.getRegion()
		// this.getcamptags()
		this.getcolCate()
		window.addEventListener('scroll', this.scrollToTop)

	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	// 销毁监听
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		getcolCate(){
				var data={
					organ_id:13
				}
				getcolCate(data).then(res => {
				if (res.data.code == 200) {
					this.colCate=res.data.data.left
					console.log("基地",this.colCate)
				}
				// loading.close();
			})
		},
	
		goCourse(e){
		this.$router.push({
				path: '/Courselist',
				name: '/Courselist',
				query: {
					category_id:e
				}
			});
		},	
		gocampmap(){
		this.$router.push({
				path: '/Campmap',
				name: '/Campmap',
				query: {
				}
			});
		},	
		goHref(){
			window.location.href="http://xh.wanjiaxiao.cn/seeyon/index.jsp"
			// window.open()
		},	
		manageurl(e) {
			console.log('Site', e)
			if (e != '/') {
				window.open(e)
			}
			this.manage_url = '/'
			// window.location.href = e;

		},
		vanlinkgo(e) {
			console.log(e)
			this.$router.push({
				path: e.link,
				name: e.link,
				query: {
				}
			});
		},
		vannavmenushow() {
			this.vannavshow = false
		},
		handleResize() {
			this.top_bannerWidth = 0;
			this.screenWidth = window.innerWidth;
			this.top_bannerWidth = window.innerWidth / 3.42
			console.log('screenWidth', this.screenWidth, this.top_bannerWidth)
			this.screenHeight = window.innerHeight;
		},
		getcamptags() {
			var data = {

			}
			getcamptags(data).then(res => {
				if (res.data.code == 200) {
					var list = []
					for (var item of res.data.data) {
						list.push({
							text: item.title,
							value: item.id
						})
					}
					this.vancamptags = list
					this.camptags = res.data.data
				}
			})
		},
		getbottomnav() {
			var data = {
				page_index: 1,
				page_size: 15,
				flag: 99
			}
			getbottomnav(data).then(res => {
				this.bottomnav = res.data.data.list
			})
		},
		gobottomnav(type, link) {
			if (type == 1) {
				this.$router.push({
					path: link
				});
			} else if (type == 2) {
				window.location.href = link;
			}
		},
		logout() {
			var that = this
			this.$confirm('是否确认退出登录?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$alert("已退出登录", '', {
					confirmButtonText: '确认',
					callback: action => {
						localStorage.setItem('token', '')
						localStorage.setItem('refreshToken', '')
						that.$router.go(0)
					}
				});
			}).catch(() => {

			});
		},
		
		scrollToTop() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			this.scrolltop = scrollTop
			if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
				this.tops = true
			} else {
				this.tops = false
			}
		},
	
		showstep(ind) {
			this.$refs.carousel.setActiveItem(ind)
		},
		goplate(id) {
			this.modules = id
			this.page_index = 1
			this.getlist()
		},
		getPlate() {
			var data = {
				flag: 99
			}
			getPlate(data).then(res => {
				this.platelist = res.data.data
			})
		},
		showphonebox() {
			this.phoneboxshow = true
		},
		closephonebox() {
			this.phoneboxshow = false
		},
	  	goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
		gohome(e) {
			this.$router.push({
				path: "/Home1",
				name: "/Home1",
				query: {
				}
			});
		},
		getRegion() {
			var data = {}
			getRegion(data).then(res => {
				var list = [
					{
						text: '全部地区',
						value: ''
					}
				]
				for (var item of res.data.data) {
					list.push({
						text: item.title,
						value: item.id
					})
				}
				this.vanregionlist = list
				this.regionlist = res.data.data


			})
		},
		getMapcamp() {
			var data = {
				type: this.camptype,
			}
			getMapcamp(data).then(res => {
				console.log(res)

				this.maplist = res.data.data
				this.openmap = res.data.data[0]
				const loading = this.$loading({
					lock: true,
					text: '页面载入……',
					// spinner: 'el-icon-loading',
					background: '#ffffff'
				});
				loading.close();
			})
		},
		infoWindowClose(index) {
			this.showinfowindow = false
		},
		infoWindowOpen(index) {
			this.openmap = this.maplist[index]
			this.showinfowindow = true
			console.log(this.maplist[index])
		},

		getpcset() {
			var data = {
				flag: 99
			}
			getPc(data).then(res => {
				this.pcsetdata = res.data.data
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				loading.close();
			})
		},
		camptypetab(val) {
			this.region_type = val
			this.page_index = 1
			this.getlist()
		},
		tagstypetab(val) {
			this.tags_type = val
			console.log(val)
			this.page_index = 1
			this.getlist()
		},
		pagechange(val) {
			this.page_index = val
			this.getlist()
		},
		handletags(id){
			
			this.tags_type=id
			this.page_index=1
			this.getlist()
		},
		handleSearch(){
			this.page_index=1
			this.getlist()

		},
		getlist() {
			var data = {
				type: this.camptype,
				page_index: this.page_index,
				region_type: this.region_type,
				tags: this.tags_type,
				modules: this.modules,
				title: this.stitle,
				page_size: 12,
				organ_id:13
			}
			getsupplierlst(data).then(res => {
				console.log(res.data)
				this.camplist = res.data.data.list
				this.total = res.data.data.total
			}).catch(error => {
				console.error(error);
			});
		},
		handleClick(e) {
			console.log(e, this.category_id)
			this._getNewslist()
		},
		onitemopen(index) {
			this.newsiconon = index
		},
		gettypes() {
			var data = {}
			getCategory(data).then(res => {
				console.log(res.data)
				this.types = res.data.data
				this.category_id = res.data.data[0].id
				this._getNewslist()
			}).catch(error => {
				console.error(error);
			});
		},
		/*
		 * 查看详情
		 * */
		detail(e) {
			this.$router.push({
				path: "/CampDetails",
				name: "CampDetails",
				query: {
					id: e
				}
			});
		},
		gomodules(e) {
			if (e) {
				window.location.href = e;
			}
		},
	}
};
</script>

<style scoped>
.camp_box{
	widows: 100%;
	display: flex;
	flex-wrap: wrap;
	position: absolute;
	bottom: 0px;
	right: 0px;
}
.camp_tag{
	
	width: 60px;
	color: #fff;
	font-size: 12px;
	height: 20px;
	line-height: 20px;
	background-color: red;
	margin-right:3px;
}
.top{
	background-image: url(../../../static/img/topbanner.png);
	position: relative;
	width: 100%;
	height: 140px;
}
.search{
	width: 250px;
	position: absolute;
	right: 120px;
	display: flex;
	top: 70px;
}
.nav{
	position: absolute;
	display: flex;
	color: #fff;
	right: 60px;
	top: 50px;

}
.nav_box{
	margin-right: 50px;
}
.nav_box:hover{
	cursor: pointer;
}
.campbox{
	display: flex;
	flex-wrap: wrap;
	margin-left: 60px;
	width: 100%;
	margin: 0 auto;
}
.pages_total{
	width: 100%;
	margin-bottom: 30px;
}
.homecamp_item {
	width: 22vw;
	/* height: 310px; */
	border-radius: 5px;
	background: #ffffff;
	margin-left: 2.2vw;
	margin-top: 20px;
}

.column2_img {
	width: 100%;
	height: 216px;
}

.column2_img_p {
	width: 100%;
	height: 90px;
}

.column2_img img {
	width: 100%;
	height: 100%;
	border-radius: 5px 5px 0px 0px;
}

.column2_img_p img {
	width: 100%;
	height: 100%;
	border-radius: 5px 5px 0px 0px;
}

.column2_title {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 0px 0px 10px 10px;
	padding-bottom: 15px;
}

.hcamp_title {
	padding: 10px;
	border-radius: 0px 0px 10px 10px;
	padding-bottom: 15px;
}

.item_title {
	font-size: 16px;
	font-weight: 600;
	color: #424244;
	/* margin-bottom: 15px; */
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	margin-bottom: 5px;
	text-overflow: ellipsis;
	width: 22vw;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
}

.item_subtitle {
	font-size: 14px;
	color: #909399;
	text-align: center;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.homecamp_msg {
	font-size: 14px;
	color: #909399;
	text-align: left;
}
.homecamp_item:hover{
		/* box-shadow: 0 3px 20px #0042ff; */
		box-shadow: 0 3px 20px rgba(247, 186, 93, 0.8);
	}
.hcamp_button {
	display: flex;
	padding: 0px 10px;
}

.el-tag--dark {
	border: 0px;
	margin: 0px 2px;
}

.bm-view {
	width: 100%;
	height: 450px;
}

.camplist {
	margin-top: 20px;
}

.campitems {
	/* margin-bottom: 20px; */
	padding: 20px;
	background: #fff;
	transition: all .3s;
	-webkit-transition: all .3s;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.campitems:hover {
	box-shadow: 0 3px 20px rgba(0, 200, 169, .8);
}

.campitem_imgbox {
	position: relative;
	width: 337px;
	height: 161px;
	overflow: hidden;
}

.campitem_imgbox img {
	width: 100%;
	height: 100%;
}

.campitem_tags {
	position: absolute;
	top: -16px;
	left: -7px;
	z-index: 1;
	display: flex;
	/* justify-content: flex-end;
			align-items: flex-end; */
}

.titleContent {
	>div {
		margin: 15px;
	}
}

.title {
	height: 32px;
	font-weight: 600;
	font-size: 12px;
	line-height: 32px;
	margin-left: 5px;
	padding-left: 5px;
	position: relative;
	color: #000;
	z-index: 0;
}

.title1 {
	display: inline-block;
	position: relative;
	width: 49px;
	height: 26px;
	line-height: 26px;
	padding-left: 15px;
	background: red;
	left: -8px;
	color: #fff;


	&:after {
		content: "";
		position: absolute;
		height: 0;
		width: 0;
		border-top: 12px solid transparent;
		border-bottom: 15px solid transparent;
		border-left: 8px solid red;
		right: -8px;
	}
}

.campitem_tag {
	/* height: 24px; */
	/* padding: 0 8px; */
	background: red;
	/* color: #fff;
		    line-height: 24px;
		    font-size: 12px;
			margin-left: 5px; */
}

.campitem_msg {
	width: 750px;
	height: 161px;
	display: flex;
	flex-direction: column;
	margin-left: 10px;
	/* justify-content: ; */

}

.campitem_msg_title {
	color: #FE7C2B;
	font-size: 18px;
	display: flex;
	align-items: center;
	padding: 0 10px 10px 0;
	margin-bottom: 10px;
	border-bottom: 1px solid #e9e9e9;
	font-weight: 400;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	/* line-height: 24px; */
}

.campitem_msg_title span {
	/* 	    position: absolute;
		    top: 0;
		    left: 0; */
	z-index: 1;
	width: 60px;
	height: 24px;
	background: #FE7C2B;
	color: #fff;
	font-size: 14px;
	text-align: center;
	line-height: 24px;
	margin-right: 10px;
}

.campitem_msg_introduce {
	line-height: 30px;
	font-size: 16px;
	/* margin: 5px 0px; */
	/* padding-top: 15px; */
	display: flex;
	align-items: center;
	overflow: hidden;
	text-align: left;

}

.campitem_msg_button {
	/* height: 42px; */
	height: 34px;
	/* margin-top: 15px; */
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
}

.msg_button {
	z-index: 1;
	width: 134px;
	height: 34px;
	background: #FE7C2B;
	color: #fff;
	line-height: 34px;
	text-align: center;
	border-radius: 4px;
}

.screen_box {
	margin-top: 30px;
	background: #fff;
	border: 1px solid #e9e9e9;
	border-bottom: 0;
	width: 100%;
	margin-left: 43px;
	/* display: flex;
	justify-content: center; */

}

.screen_items {
	/* width: 1100px; */
	display: flex;
	flex-wrap: wrap;
	/* white-space: nowrap; */
	align-items: flex-start;
	/* overflow: scroll;   */
	overflow: auto;
	white-space: nowrap;
	overflow-x: auto;
	overflow-y: hidden;

	/* padding-left: 134px; */


	border-bottom: 1px solid #e9e9e9;

}

.screen_title_box {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.screen_title {
	width: 120px;
	padding: 19px 0;
	text-align: center;
	background: #f4f4f4;
	flex-shrink: 0;
	flex-basis: auto;
	flex-grow: 0;
	display: inline-block;
}

.screen_item {
	width: 100px;
	margin: 13px 0 13px 15px;
	cursor: pointer;
	height: 34px;
	line-height: 34px;
	text-align: center;
	flex-shrink: 0;
	flex-basis: auto;
	flex-grow: 0;
	display: inline-block;
}

.screen_item_a {
	width: 100px;
	margin: 13px 0 13px 15px;
	cursor: pointer;
	height: 34px;
	line-height: 34px;
	text-align: center;
	background: #FE7C2B;
	color: #fff;
	flex-shrink: 0;
	flex-basis: auto;
	flex-grow: 0;
	display: inline-block;

}

.screen_item:hover {
	background: #FE7C2B;
	color: #fff;
}</style>